(() => {
  const form = document.querySelector('[data-manual-reservation-form]');
  if (!form || !window.OTF) return;
  const query = new URLSearchParams(window.location.search);
  const state = window.OTF.getBookingState();
  const values = {
    origin: query.get('origin') || state.origin?.iata || state.origin?.display || '',
    destination: query.get('destination') || state.destination?.iata || state.destination?.display || '',
    departureDate: query.get('departure') || state.departureDate || '',
    returnDate: query.get('return') || state.returnDate || '',
    passengers: query.get('passengers') || (state.passengers ? Object.values(state.passengers).reduce((sum, value) => sum + Number(value || 0), 0) : 1)
  };
  Object.entries(values).forEach(([name, value]) => {
    const field = form.querySelector(`[data-manual-field="${name}"]`);
    if (field && value !== undefined && value !== null) field.value = String(value);
  });
  const departure = form.querySelector('[data-manual-field="departureDate"]');
  const returning = form.querySelector('[data-manual-field="returnDate"]');
  const today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
  if (departure) departure.min = today.toISOString().slice(0, 10);
  if (returning) returning.min = departure?.value || today.toISOString().slice(0, 10);
  departure?.addEventListener('change', () => {
    returning.min = departure.value;
    if (returning.value && returning.value < departure.value) returning.value = departure.value;
  });
})();
